import { REAL_TIME_ROUTES } from "@constants"
import { Box, ButtonBase } from "@mui/material"
import { IconSeeker } from "@ui-seeker/core"
import { analyzerFilters, openEvolutionModal } from "Pages/AnalyzersV2/@signals"
import { dsColorNew } from "@palette"
import React from "react"

const LinkButton = ({ icon, label, ...props }) => <ButtonBase {...props} sx={{
	gap: 0.75, height: 28, px: 1.1, borderRadius: '7px', fontFamily: 'inherit', fontSize: 12, fontWeight: 500,
	color: dsColorNew.appBlue, backgroundColor: dsColorNew.white, border: `1px solid ${dsColorNew.grayBorder}`,
	'&:hover': { borderColor: dsColorNew.appBlue, backgroundColor: dsColorNew.hoverBgLight },
}}>
	<IconSeeker icon={icon} sx={{ fontSize: 12 }}/>
	{label}
</ButtonBase>

const openInNewTab = url => ({
	onClick: e => {
		window.open(url, "_blank")
		if (e.ctrlKey) e.preventDefault()
	},
	onAuxClick: e => {
		if (e.button === 1) {
			window.open(url, "_blank")
			e.preventDefault()
		}
	},
})

export default function PopoverLinks({ id_search, screenshot, evolutionFilter, priceData, hideEvolution = false, askOrigin = null }) {

	return <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, px: 1.75, py: 1.25, borderTop: `1px solid ${dsColorNew.grayBorder}`, backgroundColor: dsColorNew.tableRowAlt, borderRadius: '0 0 12px 12px' }}>
		{!hideEvolution && <Box data-tour-id="tour-popover-evolution">
			<LinkButton
				icon="chart-line"
				label="Evolution"
				title="Evolution Chart"
				onClick={() => {
					openEvolutionModal.value = {
						price_data: evolutionFilter,
						filters: analyzerFilters.value,
						tableRows: [ priceData ],
						// the cell it was opened from, for the modal's "Ask Iris" (CU-869fkdhjv phase 3)
						askOrigin,
					}
				}}
			/>
		</Box>}
		{ !!id_search && <Box data-tour-id="tour-popover-realtime">
			<LinkButton icon="magnifying-glass" label="Real time" title="Real-Time Searches" {...openInNewTab(`${REAL_TIME_ROUTES.SEARCHES_PATH}?idSearch=${id_search}`)}/>
		</Box>}
		{ !!screenshot && <Box data-tour-id="tour-popover-screenshot">
			<LinkButton icon="image" label="Screenshot" title="Screenshot" {...openInNewTab(screenshot)}/>
		</Box>}
	</Box>
}
